import React from 'react';

const TestPage = () => {
  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <h1>测试页面</h1>
      <p>如果您能看到这个页面，说明路由系统正常工作。</p>
    </div>
  );
};

export default TestPage; 